import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SimpleCheckModalComponent } from '../../../modals/simple-check-modal.component';
import { StornoMap } from '../../../../core/bookingParameters';

@Component({
  selector: 'app-guide-details-storno',
  imports: [CommonModule, SimpleCheckModalComponent, ReactiveFormsModule],
  standalone: true,
  template: `
    <div class="flex flex-col w-full">
      <label for="storno" class="mb-2 text-sm font-medium text-gray-700"
        >Stornogrund</label
      >
      <div class="flex flex-row gap-x-4">
        <div class="flex justify-center h-fit self-center">
          <button
            (click)="onToggleDelete()"
            type="button"
            class="shrink-0 rounded-md bg-red-500 px-1.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-red-400 active:bg-red-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
              />
            </svg>
          </button>
        </div>
        <div class="flex flex-col w-full" [formGroup]="storno">
          <div class="flex flex-col">
            <select
              id="stornoDropdown"
              formControlName="storno"
              (change)="onSelectionChange($event)"
              class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option *ngFor="let key of stornoKeys" [value]="key">
                {{ stornoMap[key] }}
              </option>
            </select>
          </div>
          <div *ngIf="isOtherSelected" class="flex flex-row w-full pt-2">
            <input
              id="customstorno"
              type="text"
              formControlName="customStorno"
              class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Stornogrund eingeben..."
            />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="deleteToggler && storno">
      <app-simple-check-modal
        [message]="'Möchtest du den Storno entfernen?'"
        [title]="'Storno entfernen?'"
        [positiveButtonText]="'Bestätigen'"
        [negativeButtonText]="'Abbrechen'"
        (close)="onDeleteModal($event)"
      ></app-simple-check-modal>
    </div>
  `,
  styles: ``,
})
export class GuideDetailsStornoComponent implements OnInit {
  @Input({ required: true }) storno!: FormGroup;
  @Output() delete = new EventEmitter();
  deleteToggler = false;

  stornoMap = StornoMap;
  stornoKeys = Object.keys(StornoMap);

  isOtherSelected = false;
  ngOnInit(): void {
    const currentValue = this.storno.get('storno')?.value;

    if (currentValue && currentValue === 'other') {
      // Set to "other" and make the input field visible
      this.isOtherSelected = true;
      this.storno.get('stornoDropdown')?.setValue('other');
    } else {
      // Set dropdown to the valid value
      this.isOtherSelected = false;
      this.storno.get('stornoDropdown')?.setValue(currentValue);
    }
  }

  onToggleDelete() {
    this.deleteToggler = !this.deleteToggler;
  }

  onDeleteModal(value: boolean) {
    if (value) {
      this.delete.emit(true);
    }

    this.onToggleDelete();
  }

  onSelectionChange(event: Event) {
    const selValue = (event.target as HTMLSelectElement).value;
    this.isOtherSelected = selValue === 'other';
    this.storno.get('customStorno')?.reset();
  }
}
